// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format2 } from '../../constants';

/** Czechia */
const CZ: PhoneNumberData = [420, 'CZ', 9, format2];

export default CZ;
